import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { config } from '../../config';

export default function PatSidebar() {
  const [isOpen, setIsOpen] = useState(false);
  const [nonLus, setNonLus] = useState(0);
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  const API_BASE = config.apiBase;

  const isCaisseActive = () => {
    const caisseActive = localStorage.getItem('caisse_active');
    const caisseExpire = localStorage.getItem('caisse_expire');
    if (!caisseActive || caisseActive !== 'true') return false;
    if (caisseExpire && parseInt(caisseExpire) < Date.now()) return false;
    return true;
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('caisse_active');
    localStorage.removeItem('caisse_expire');
    toast.success('Déconnexion réussie');
    navigate('/login');
  };

  const checkMessages = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return;
      
      const response = await fetch(`${API_BASE}/get_messages_techniques.php`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      if (data.success) {
        setNonLus(data.non_lus);
      }
    } catch (error) {
      console.error('Erreur chargement messages:', error);
    }
  };

  useEffect(() => {
    checkMessages();
    const interval = setInterval(checkMessages, 30000); // Vérifier toutes les 30 secondes
    return () => clearInterval(interval);
  }, []);

  const menuItems = [
    { path: '/pat/dashboard', name: 'Dashboard', icon: '📊' },
    { path: '/tv-sahel', name: 'TV Sahel', icon: '📺' },
     { path: '/admin/messagerie', name: 'Messagerie', icon: '💬' },
    { path: '/pat/activation', name: 'Activation', icon: '🔑' },
    { path: '/pat/caisse', name: 'Recharge physique', icon: '💰', besoinActivation: true },
    { path: '/pat/recharges', name: 'Recharges à distance', icon: '📱', besoinActivation: true },
    { path: '/pat/debit-repas', name: 'Débit Repas', icon: '🍽️', besoinActivation: true },
    { path: '/pat/debit-bus', name: 'Débit Bus', icon: '🚌', besoinActivation: true },
    { path: '/pat/moyens-paiement', name: 'Moyens de paiement', icon: '💳', besoinActivation: true },
    { path: '/pat/transactions', name: 'Transactions', icon: '📜' },
    { path: '/pat/feed', name: 'Fil d\'actualité', icon: '✨' },
    { path: '/pat/mes-medias', name: 'Mes médias', icon: '📱' },
    { path: '/pat/profile', name: 'Mon profil', icon: '👤' },
    { path: '/messages-techniques', name: 'Messages techniques', icon: '💬' },
  ];

  const MobileMenu = () => (
    <>
      {isOpen && (
        <div className="fixed inset-0 bg-black/50 z-40 lg:hidden" onClick={() => setIsOpen(false)} />
      )}
      <div className={`
        fixed top-0 left-0 h-full w-64 bg-gradient-to-b from-blue-800 to-blue-950 text-white z-50 transform transition-transform duration-300 ease-in-out lg:hidden
        ${isOpen ? 'translate-x-0' : '-translate-x-full'}
      `}>
        <div className="flex flex-col h-full">
          <div className="flex-shrink-0 p-5 border-b border-blue-700/50">
            <div className="flex justify-between items-center">
              <div className="text-center flex-1">
                <div className="w-12 h-12 bg-blue-600/30 rounded-full flex items-center justify-center mx-auto mb-2">
                  <span className="text-2xl">🏪</span>
                </div>
                <h2 className="text-lg font-bold">CROUS Niger</h2>
                <p className="text-xs text-blue-300 mt-0.5">Espace PAT</p>
                <p className="text-xs text-blue-400/70 mt-1">{user.prenom} {user.nom}</p>
              </div>
              <button onClick={() => setIsOpen(false)} className="text-white/70 hover:text-white text-2xl">✕</button>
            </div>
          </div>
          
          <div className="flex-1 overflow-y-auto py-3 px-3 space-y-1">
            {menuItems.map((item) => {
              const isDisabled = item.besoinActivation && !isCaisseActive();
              return (
                <NavLink
                  key={item.path}
                  to={item.path}
                  onClick={(e) => {
                    if (isDisabled) {
                      e.preventDefault();
                      toast.error('Veuillez d\'abord activer votre caisse');
                    }
                    setIsOpen(false);
                  }}
                  className={({ isActive }) =>
                    `flex items-center gap-3 px-3 py-2 rounded-lg transition text-sm relative ${
                      isActive && !isDisabled
                        ? 'bg-blue-600 text-white'
                        : isDisabled
                        ? 'opacity-50 cursor-not-allowed text-blue-300/50'
                        : 'hover:bg-blue-700/50 text-blue-100'
                    }`
                  }
                >
                  <span className="text-lg">{item.icon}</span>
                  <span className="flex-1">{item.name}</span>
                  {isDisabled && <span className="text-xs">🔒</span>}
                  {item.path === '/messages-techniques' && nonLus > 0 && !isDisabled && (
                    <span className="flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-xs font-bold">
                      {nonLus > 9 ? '9+' : nonLus}
                    </span>
                  )}
                </NavLink>
              );
            })}
          </div>
          
          <div className="flex-shrink-0 p-3 space-y-2 border-t border-blue-700/50">
            <div className="px-3 py-1.5 bg-blue-900/50 rounded-lg">
              <div className="flex items-center gap-2">
                <div className={`w-2 h-2 rounded-full ${isCaisseActive() ? 'bg-green-400 animate-pulse' : 'bg-red-400'}`}></div>
                <span className="text-xs text-blue-200">Caisse : {isCaisseActive() ? 'Activée' : 'Désactivée'}</span>
              </div>
            </div>
            <button onClick={() => { handleLogout(); setIsOpen(false); }} className="w-full flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-red-600/30 text-blue-100 transition text-sm">
              <span className="text-lg">🚪</span>
              <span>Déconnexion</span>
            </button>
          </div>
        </div>
      </div>
    </>
  );

  const DesktopSidebar = () => (
    <div className="hidden lg:flex lg:flex-col lg:w-64 lg:fixed lg:left-0 lg:top-0 lg:h-full lg:bg-gradient-to-b lg:from-blue-800 lg:to-blue-950 lg:text-white lg:shadow-xl">
      <div className="flex flex-col h-full">
        <div className="flex-shrink-0 p-5 border-b border-blue-700/50">
          <div className="text-center">
            <div className="w-14 h-14 bg-blue-600/30 rounded-full flex items-center justify-center mx-auto mb-2">
              <span className="text-2xl">🏪</span>
            </div>
            <h2 className="text-lg font-bold">CROUS Niger</h2>
            <p className="text-xs text-blue-300 mt-0.5">Espace PAT</p>
            <p className="text-xs text-blue-400/70 mt-1">{user.prenom} {user.nom}</p>
          </div>
        </div>
        
        <div className="flex-1 overflow-y-auto py-3 px-3 space-y-1">
          {menuItems.map((item) => {
            const isDisabled = item.besoinActivation && !isCaisseActive();
            return (
              <NavLink
                key={item.path}
                to={item.path}
                onClick={(e) => {
                  if (isDisabled) {
                    e.preventDefault();
                    toast.error('Veuillez d\'abord activer votre caisse');
                  }
                }}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2 rounded-lg transition text-sm relative ${
                    isActive && !isDisabled
                      ? 'bg-blue-600 text-white'
                      : isDisabled
                      ? 'opacity-50 cursor-not-allowed text-blue-300/50'
                      : 'hover:bg-blue-700/50 text-blue-100'
                  }`
                }
              >
                <span className="text-lg">{item.icon}</span>
                <span className="flex-1">{item.name}</span>
                {isDisabled && <span className="text-xs">🔒</span>}
                {item.path === '/messages-techniques' && nonLus > 0 && !isDisabled && (
                  <span className="absolute right-2 top-1/2 -translate-y-1/2 flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-xs font-bold text-white animate-pulse">
                    {nonLus > 9 ? '9+' : nonLus}
                  </span>
                )}
              </NavLink>
            );
          })}
        </div>
        
        <div className="flex-shrink-0 p-3 space-y-2 border-t border-blue-700/50">
          <div className="px-3 py-1.5 bg-blue-900/50 rounded-lg">
            <div className="flex items-center gap-2">
              <div className={`w-2 h-2 rounded-full ${isCaisseActive() ? 'bg-green-400 animate-pulse' : 'bg-red-400'}`}></div>
              <span className="text-xs text-blue-200">Caisse : {isCaisseActive() ? 'Activée' : 'Désactivée'}</span>
            </div>
          </div>
          <button onClick={handleLogout} className="w-full flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-red-600/30 text-blue-100 transition text-sm">
            <span className="text-lg">🚪</span>
            <span>Déconnexion</span>
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <DesktopSidebar />
      <MobileMenu />
      <button 
        onClick={() => setIsOpen(true)} 
        className="fixed top-4 left-4 z-30 lg:hidden bg-blue-600 text-white p-2 rounded shadow-lg relative"
      >
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
        </svg>
        {nonLus > 0 && (
          <span className="absolute -top-1 -right-1 flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-xs font-bold text-white">
            {nonLus > 9 ? '9+' : nonLus}
          </span>
        )}
      </button>
    </>
  );
}